// extracted by mini-css-extract-plugin
export default {"container":"NoPage_container__T7-Q9","link":"NoPage_link__j-Bq0"};